export default __webpack_public_path__ + "static/media/bg.89e95681.jpg";